<template>
  <app-layout>
    <div class="bg-white shadow-lg p-4 lg:p-6 lg:py-12 lg:px-16 mx-auto lg:max-w-7xl mb-10">
      <h1 class="text-3xl md:text-5xl mb-8">{{ $trans('app.menu.legal-terms') }}</h1>
      <h2>Editeur du site</h2>
      <p>
        Le site internet talents-carriere.fr est édité par la société DSPACE, dont le siège social est situé au
        Centre commercial des Grands Hommes, Place des Grands Hommes, 33000 Bordeaux.
        SIRET :
        Directeur de la publication : Jean François Despeyroux
      </p>

      <h2>Hébergement du site</h2>

      <p>Le site internet talents-carriere.fr est hébergé par la société OVH
        SIRET : 424 761 419 00045
        Siège social : 2 rue Kellermann, 59100 Roubaix
        SAS au capital de 10 059 500 €</p>

      <h2>Propriété intellectuelle</h2>

      <p>Toute représentation totale ou partielle de ce site par quelle que personne que ce soit, sans
        l'autorisation expresse de l'éditeur du site est interdite et constitue une contrefaçon sanctionnée par
        les articles du Code de la propriété intellectuelle.
      </p>

    </div>
  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import BubbleButton from '@/Components/BubbleButton'
import BubbleLink from '@/Components/BubbleLink'
import ConditionalLink from '@/Components/ConditionalLink'


export default {
  components: {AppLayout, BubbleButton, BubbleLink, ConditionalLink},

  computed: {},

  methods: {}
}
</script>

<style scoped>
h1, h2, h3 {
  @apply text-dark-blue;
}

h2 {
  @apply mt-6 mb-2 ;
}

p {
  @apply mb-1;
}
</style>
